import classNames from 'classnames';
import * as React from 'react';
import { mapToCssModules } from '../common/utilities';
import IModalHeaderProps from './ModalHeader.props';

/**
 * ModalHeader component
 */
export default class ModalHeader extends React.Component<IModalHeaderProps> {
    public render(): JSX.Element {
        let closeButton;
        const {
            className,
            cssModule,
            children,
            toggle,
            tag,
            wrapTag,
            closeAriaLabel,
            closeButtonLabel,
            id,
            ...attributes
        } = this.props;

        const Tag = tag || 'h5';
        const WrapTag = wrapTag || 'div';
        const classes = mapToCssModules(classNames(className, 'msc-modal__header'), cssModule);

        if (toggle) {
            closeButton = (
                <button type='button' onClick={toggle} className={mapToCssModules('msc-modal__close-button', cssModule)} aria-label={closeAriaLabel || 'Close'}/>
            );
        }

        return (
            <WrapTag {...attributes} className={classes}>
                {   children && <Tag className={mapToCssModules('msc-modal__title', cssModule)}>
                            {children}
                    </Tag>
                }
                {closeButton}
            </WrapTag>
        );
    }
}
